import { List, ListItem, ListItemText, ListItemIcon, Card, CardContent, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Checkbox } from "@material-ui/core";
import React, {Component} from "react";

/**
 * shows - список шоу
 * 
 * onSaveClick({use_date_range, date_begin, date_end})
 * onCancelClick()
 */

class SaveShowDialog extends Component {

    constructor(props) {
        super(props)

        this.state = {
            use_date_range: false,
            shows_checked: this.props.shows.map(show => { return {id: show.id, checked: true} })
        }

        // Установка данных по умолчанию для выбора периода дат
        if (this.props.shows && this.props.shows.length) {

            let date_begin = new Date(this.props.shows[0].date)
            let date_end = new Date(this.props.shows[0].date)

            for (let i = 1; i < this.props.shows.length; i++) {
                let date = new Date(this.props.shows[i].date)
                if (date < date_begin) {
                    date_begin = date
                }
                if (date > date_end) {
                    date_end = date
                }
            }

            this.state.date_begin = `${date_begin.getFullYear()}-${String(date_begin.getMonth()+1).padStart(2, "0")}-${String(date_begin.getDate()).padStart(2, "0")}`
            this.state.date_end = `${date_end.getFullYear()}-${String(date_end.getMonth()+1).padStart(2, "0")}-${String(date_end.getDate()).padStart(2, "0")}`

        }

    }

    readyToSave = (shows) => {
        
        // Дата начала должна быть раньше даты конца.
        if (this.state.use_date_range) {
            if (this.state.date_begin > this.state.date_end) {
                return false
            }
        }

        // Проверка, если не выбрано ни одного шоу.
        let no_show_selected = true
        for (let ch of this.state.shows_checked) {
            let s = shows.find(sh => sh.id === ch.id)
            if (!s) {
                continue
            }
            if (ch.checked) {
                no_show_selected = false
                break
            }
        }
        if (no_show_selected) {
            return false
        }

        return true        
    }

    isShowChecked = (show) => {
        let s = this.state.shows_checked.find(sh => sh.id === show.id)
        return s ? s.checked : false
    }

    render() {

        if (this.state.use_date_range) {
            let date_begin = new Date(this.state.date_begin.split(" "))
            let date_end = new Date(this.state.date_end.split(" "))
            var shows = this.props.shows.filter(show=>{
                let date = new Date(show.date.split(" ")[0])
                return date >= date_begin && date <= date_end
            })
        } else {
            var shows = this.props.shows
        }

        return <Dialog open fullWidth>

            <DialogTitle>Сохранить список шоу</DialogTitle>

            <DialogContent>

                {/* Карточка фильтров */}

                <Card>

                    <CardContent>

                        <Checkbox 
                            checked={this.state.use_date_range} 
                            onClick={e=>{
                                e.stopPropagation()
                                this.setState({use_date_range: !this.state.use_date_range})
                            }}
                        /> Указать период

                        <div style={{display:"flex", gap:"10px"}}>

                            <TextField 
                                disabled = {!this.state.use_date_range}
                                style={{flex: "1 1 auto"}}
                                type = "date"
                                label = "Начало"
                                value = {this.state.date_begin}
                                onChange = {e=>{
                                    e.stopPropagation()
                                    this.setState({date_begin: e.target.value})
                                }}                
                            />

                            <TextField 
                                disabled = {!this.state.use_date_range}
                                style={{flex: "1 1 auto"}}
                                type = "date"
                                label = "Конец"
                                value = {this.state.date_end}
                                onChange = {e=>{
                                    e.stopPropagation()
                                    this.setState({date_end: e.target.value})
                                }}                
                            />

                        </div>

                    </CardContent>

                </Card>

                {/* Список шоу */}

                <List>
                    {shows.map((show, key) => <ListItem key={key}>
                        <ListItemIcon>
                            <Checkbox
                                checked = {this.isShowChecked(show)}
                                onClick={e=>{
                                    e.stopPropagation()
                                    for (let ch of this.state.shows_checked) {
                                        if (ch.id === show.id) {
                                            ch.checked = !ch.checked
                                            break
                                        }
                                    }
                                    this.setState({shows_checked: this.state.shows_checked})
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText 
                            key = {key}
                            primary = {show.name}
                            secondary = {show.date}
                        />
                    </ListItem>)}
                </List>

            </DialogContent>

            <DialogActions>

                <Button
                    disabled={!this.readyToSave(shows)}
                    onClick={e=>{
                        e.stopPropagation()
                        let checked_shows = shows.filter(show => {
                            let ch = this.state.shows_checked.find(c => c.id === show.id)
                            return ch ? ch.checked : false
                        })
                        if (typeof this.props.onSaveClick === "function") {
                            this.props.onSaveClick(checked_shows)
                        }
                    }}
                >Сохранить</Button>

                <Button
                    onClick={e=>{
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >Отмена</Button>

            </DialogActions>

        </Dialog>
    }

}

export default SaveShowDialog